import { render, staticRenderFns } from "./EventCardListItemFooter.vue?vue&type=template&id=15954464&scoped=true&"
import script from "./EventCardListItemFooter.vue?vue&type=script&lang=ts&"
export * from "./EventCardListItemFooter.vue?vue&type=script&lang=ts&"
import style0 from "./EventCardListItemFooter.vue?vue&type=style&index=0&id=15954464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15954464",
  null
  
)

export default component.exports